import { cloudcharge } from './cloudcharge';
import { defa } from './defa';
import { base } from './base';
import { Theme } from './theme';

export const themes: Theme[] = [cloudcharge, defa, base];

export const themesMap = {
    cloudcharge,
    defa,
    base,
};
